import React, {PropTypes} from 'react';
import {AppBar, Popover, MenuItem, Menu, FlatButton} from 'material-ui';
import PersonIcon from 'material-ui/svg-icons/social/person';
import {white} from 'material-ui/styles/colors';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userActions from '../../actions/userAction';
import {blueGrey800} from 'material-ui/styles/colors';
import {Link} from 'react-router';


class MyAppBar extends React.Component {

    constructor(state, context) {
        super(state, context);
        this.state = {
            open: false,
            anchor: null
        };
    }

    openPopover(e) {
        this.setState({open: !this.state.open, anchor: e.currentTarget});
    }

    onLogout() {
        this.setState({open: !this.state.open});
        this.props.userActions.logout();
        this.context.router.push('/login');
    }

    render() {
        const styles = {
            largeIcon: {
                width: 36,
                height: 36
            },
            large: {
                height: 72
            }
        };
        const openPopover = this.openPopover.bind(this);
        const logout = this.onLogout.bind(this);
        const style = (this.props.isLoggedIn) ? {
                position: 'fixed',
                top: 0,
                zIndex: 10000,
                backgrounColor: blueGrey800
            } : {
                position: 'fixed',
                top: -75,
                zIndex: 10000000,
                backgrounColor: blueGrey800
            };
        const name = (this.props.me) ? this.props.me.firstname + ' ' + this.props.me.lastname : '';
        const loginInfo = (
            <div>
                <FlatButton labelStyle={{color: white}} icon={<PersonIcon color={white}/>} label={name}
                            style={styles.large} iconStyle={styles.largeIcon} onClick={openPopover}/>
                <Popover
                    open={this.state.open} anchorEl={this.state.anchor}
                    anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                    targetOrigin={{horizontal: 'left', vertical: 'top'}}
                    onRequestClose={openPopover}
                >
                    <Menu>
                        <MenuItem primaryText="Mon profil" disabled/>
                        <MenuItem primaryText="Se déconnecter" onClick={logout}/>
                    </Menu>
                </Popover>
            </div>);
        return (
            <AppBar showMenuIconButton={false} title={<Link to="/">Dashboard</Link>} titleStyle={{padding:'10px 0'}} style={style}>
                {loginInfo}
            </AppBar>
        );
    }
}

MyAppBar.contextTypes = {
    router: PropTypes.object
};

MyAppBar.propTypes = {
    me: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    userActions: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        userActions: bindActionCreators(userActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAppBar);


/** WEBPACK FOOTER **
 ** ./src/components/MyAppBar/index.js
 **/